import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { isAuthenticated, isStudent, isCompany, isAdmin, isCoordinator, logout } from '../utils/auth';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setLoggedIn(isAuthenticated());
  }, [location]);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    await authService.logout();
    logout();
    setLoggedIn(false);
    setIsMenuOpen(false);
    navigate('/');
    window.location.reload();
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <div className="logo-icon">🎓</div>
          <h2>CampusRecruit</h2>
        </Link>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="nav-links">
            <Link to="/" className={`nav-link ${isActive('/')}`} onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/placement-drives" className={`nav-link ${isActive('/placement-drives')}`} onClick={() => setIsMenuOpen(false)}>
              Placement Drives
            </Link>
            <Link to="/colleges" className={`nav-link ${isActive('/colleges')}`} onClick={() => setIsMenuOpen(false)}>
              Colleges
            </Link>
            <Link to="/companies" className={`nav-link ${isActive('/companies')}`} onClick={() => setIsMenuOpen(false)}>
              Companies
            </Link>
            <Link to="/about" className={`nav-link ${isActive('/about')}`} onClick={() => setIsMenuOpen(false)}>
              About
            </Link>
            <Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={() => setIsMenuOpen(false)}>
              Contact
            </Link>
          </div>
          <div className="nav-auth">
            {loggedIn ? (
              <>
                <Link to="/notifications" className={`nav-link ${isActive('/notifications')}`} onClick={() => setIsMenuOpen(false)}>
                  Notifications
                </Link>
                {isStudent() && (
                  <Link to="/applications" className="nav-link applications-btn" onClick={() => setIsMenuOpen(false)}>
                    Applications
                  </Link>
                )}
                {isCompany() && (
                  <Link to="/company-portal" className="nav-link applications-btn" onClick={() => setIsMenuOpen(false)}>
                    Company Portal
                  </Link>
                )}
                {isAdmin() && (
                  <Link to="/admin" className="nav-link applications-btn" onClick={() => setIsMenuOpen(false)}>
                    Admin
                  </Link>
                )}
                {isCoordinator() && (
                  <Link to="/coordinator-portal" className="nav-link applications-btn" onClick={() => setIsMenuOpen(false)}>
                    Coordinator
                  </Link>
                )}
                <button className="nav-link logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="nav-link login-btn" onClick={() => setIsMenuOpen(false)}>
                  Login
                </Link>
                {!isStudent() && (
                  <Link to="/student-register" className="nav-link register-btn" onClick={() => setIsMenuOpen(false)}>
                    Register
                  </Link>
                )}
                <Link to="/company-register" className="nav-link register-btn" onClick={() => setIsMenuOpen(false)}>
                  Register as Company
                </Link>
              </>
            )}
          </div>
        </div>

        <div className={`nav-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

